const defaultState = {}

const pages = (state = defaultState, action) => {
  switch (action.type) {
    case 'PAGES_ADD':
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export default pages



// WEBPACK FOOTER //
// ./src/reducers/pages.js